










































import { Component, Vue } from 'vue-property-decorator'
import ApiGtag, { Category } from '@/services/api-gtag'

@Component({
  components: {
    Footer: () => import('@/containers/Footer.vue')
  }
})
export default class About extends Vue {
  private uri = ''

  created() {
    this.uri = `${process.env.VUE_APP_DOCS_URL}`
    window.document.title = `${this.$i18n.t('pageTitle.about')} - LDX`
  }

  public sendHelpViewEvent(url: string) {
    ApiGtag.sendEvent(Category.Help, 'view Help', url)
  }
}
